import { makeAutoObservable } from "mobx";

class AppStore {
   public toast: any;

   constructor() {
      makeAutoObservable(this);
   }
}

export default new AppStore();
